import React from 'react'

const Modals = () => {
  return (
    <div>
    </div>
  )
}

export default Modals